module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch2.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("“M")]), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("r. ")]), _vm._v("Wentworth, I told you no the first time,” Grandpa says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Call me Charles,” the man says. His accent is definitely English. And with a name like Charles Wentworth, I’m surprised he’s not wearing a jeweled crown and holding a scepter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Charles")]), _vm._v(", Towne Chocolate Shoppe is not for sale.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But, Mr. Cabot, Regal Candy Corporation is willing to offer—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your offer doesn’t matter.” Grandpa starts moving the old-fashioned barrels around, something he always does when he’s upset. “My name’s not even Cabot. That’s on the other side of the family. You know nothing about us. You just want to swallow us into your giant company.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man leans against the counter. “We don’t want to swallow you into our giant company,” he says. “We want to give you a large sum of money and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("then")]), _vm._v(" swallow you into our giant company. You’ve done a great job here. You’re making chocolates for farmer’s markets and reenactments. You’re starting to find your way into grocery stores. You have the world’s only dog-powered waterwheel. If Regal Candy Corporation takes over, we can bring the price of your chocolate down. That will make your brand available across the country—even worldwide. We’re talking millions of dollars.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I told you we’re not interested.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mr. Wentworth smiles. “In time you’ll see it differently.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandpa smiles back. “No, we won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mr. Wentworth takes a salted caramel chocolate bar from the rack and fishes a few bills from his wallet. “If you change your mind, I’ll be staying at the Quarter Inn Hotel,” he says. “Good day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mr. Wentworth places the money on the counter and returns to his limousine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“More like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bad")]), _vm._v(" day,” Hannah says. “We’re not selling the chocolate mill, are we?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandpa kneels in front of Hannah. “We’ve worked too hard to get where we are. I’m not about to be pushed around by some fancy suit-wearing aristocrat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aristo-what?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“An aristocrat is a member of high society,” Grandpa says. “Like nobility. In Revolutionary times, they’d tootle around in horse-drawn carriages sipping tea. Nowadays, it’s stretch limousines and skim soy chai lattes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I peer out the window as the limousine pulls away. “How much was he offering?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The money doesn’t matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What if he was offering a million dollars?” I say. “A billion?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandpa hoists a heavy bag of cocoa beans onto his shoulder and starts toward the milling area. “A billion dollars is nothing compared to what we’ve got.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I look around the mill. Old beams stretch across the ceiling. The waterwheel stands still in the weak stream. “What do we have worth a billion dollars?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandpa turns to me before disappearing downstairs. “We’ve got plenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you hiding a big chest of gold down there behind the grindstone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ve got plenty!” he repeats. “Now get those dogs ready. The waterwheel needs to be turning in a few minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I look to Hannah.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sits on the floor and gathers Cocoa, Nilla, and Licorice around her. Nilla licks at her face. “I think he means we’ve got each other,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sit beside Hannah. Licorice jumps on my lap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’d still have each other if we let Regal Candy Corporation give us a big pile of money,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah strokes Nilla’s soft back. Nilla drops onto her side and exposes her belly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They wouldn’t offer us anything unless one of two things was true,” Hannah says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I let Licorice nip onto my sleeve, and I tug him around the floor. “What’s the first?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re scared of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What would they be scared of?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah shrugs. “That we could hurt their business somehow or threaten them in some way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How could we hurt Regal Candy Corporation? They invented the Choco-Whammy and the Caramel Silk Bar. Regal Candy makes practically every candy bar there is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah scratches Nilla’s belly some more. Our tiny yellow Lab’s back leg starts kicking. “Yeah, I don’t think that’s the reason, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then what’s the other possibility?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah smiles. “Regal Candy knows we’re worth way more than a suitcase full of cash.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I smile back and feel a surge of pride. It’s been a lot of work to build our company, get the mill turning, and keep it clean every day. Whatever work I’ve done, Mom, Dad, and Grandpa have put in ten times that much. The idea that someone wants to pay us money for it feels good. It means we must be doing something right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A pained whine comes from the other side of the store.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I look at Hannah.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We both leap up and run around the counter. Cocoa is lying on his side, his legs straight out. He has a worried look on his face. He groans. Around him, chewed wrappers lay scattered about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Call Mom and Dad!” Hannah screams. “Call 911!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s the matter?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cocoa’s eaten chocolate. Chocolate is poisonous to dogs!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b060185","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781338184655_ch002.vue
// module id = 69
// module chunks = 0